import { render, staticRenderFns } from "./ImageMessageElement.vue?vue&type=template&id=39be9b78&scoped=true&"
import script from "./ImageMessageElement.vue?vue&type=script&lang=babel&"
export * from "./ImageMessageElement.vue?vue&type=script&lang=babel&"
import style0 from "./ImageMessageElement.vue?vue&type=style&index=0&id=39be9b78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39be9b78",
  null
  
)

export default component.exports